import {
    Action,
    getModule,
    Module,
    Mutation,
    VuexModule
} from 'vuex-module-decorators';
import { OrderState, OrderType } from '~/interfaces/order.interface';
import apiService from '~/services/api.service';
import store from '~common-store';
import { LoadingModule } from '~common-store/modules/loading';
import { sapIdRe } from '~common/helpers';

@Module({ dynamic: true, store, name: 'order', namespaced: true })
class Order extends VuexModule implements OrderState {
    orderId = '';
    order: OrderType | null = null
    userOrders: OrderType[] = [];
    deviceIds = [] as string[];

    @Action
    setOrderId(orderId: string) {
        this.context.commit('SET_ORDER_ID', orderId);
    }

    @Action
    async searchOrder(orderId: string) {
        try {
            LoadingModule.showLoading(true);
            let order: OrderType;
            if (sapIdRe.test(orderId)) {
                order = await apiService.admingetordersap({ sap_id: orderId })
                    .then((res) => {
                        return { ...res.data, sapId: orderId };
                    });
            } else {
                order = await apiService.admingetorder({ order_id: orderId }).then((res) => res.data);
            }
            this.context.commit('SET_ORDER', order);
            LoadingModule.showLoading(false);
            this.context.commit('SET_ORDER_ID', order?.orderNumber);
            return order;
        } catch (error) {
            this.context.commit('SET_ORDER', []);
            return false;
        }
    }

    @Mutation
    SET_ORDER_ID(id: string) {
        this.orderId = id;
    }

    @Mutation
    SET_USER_ORDERS(orders: OrderType[]) {
        this.userOrders = orders;
    }

    @Mutation
    SET_ORDER(order: OrderType) {
        this.order = order;
    }
}

export const OrderModule = getModule(Order);
